import React, { useId, useState } from "react";
import { RiEyeFill, RiEyeCloseFill } from "react-icons/ri";
import { FiLock } from "react-icons/fi";
import "./AuthInput.css";

const AuthInputPassword = ({
  label,
  placeholder,
  required,
  Value,
  setValue,
  autoComplete,
  labelLayout = "floating",
  variant = "default",
  Width,
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const fieldId = useId();
  const isStacked = labelLayout === "stacked";
  const isAuth = variant === "auth";

  const labelClass = isAuth
    ? "text-sm font-semibold text-ink"
    : isStacked
      ? "text-[11px] font-bold uppercase tracking-wider text-main"
      : "absolute top-[-9px] left-3 z-10 w-fit max-w-[85%] truncate bg-card px-1 h-[16px] text-sm font-bold InputLabel text-main rounded";

  const inputClass = isAuth
    ? "pl-10 pr-11 py-2.5 h-11 border border-line bg-field text-ink placeholder:text-muted rounded-lg w-full outline-none transition-colors duration-150 focus:border-main focus:ring-2 focus:ring-main/15"
    : "px-3 py-2.5 pr-11 border border-line bg-field text-ink placeholder:text-muted rounded-md w-full outline-none InputText transition-colors duration-150 focus:border-main focus:ring-2 focus:ring-main/15";

  return (
    <div
      className={`${isStacked ? "flex flex-col gap-1.5" : "relative"} mb-4 ${
        Width ? Width : "w-full sm:w-[297px]"
      } maxInputWidth font-quicksand`}
    >
      {label && (
        <label htmlFor={fieldId} className={labelClass}>
          {label}
          {required && !isAuth && <span className="text-danger ml-0.5">*</span>}
        </label>
      )}
      <div className="relative w-full font-quicksand">
        {isAuth && (
          <FiLock
            className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-muted"
            size={17}
            aria-hidden
          />
        )}
        <input
          id={fieldId}
          type={showPassword ? "text" : "password"}
          required={required}
          placeholder={placeholder}
          aria-label={label || placeholder}
          autoComplete={autoComplete}
          className={inputClass}
          value={Value}
          onChange={(e) => setValue(e.target.value)}
        />
        <button
          type="button"
          aria-label={showPassword ? "Hide password" : "Show password"}
          className="absolute inset-y-0 right-0 px-3 py-2 text-muted hover:text-main transition-colors"
          onClick={() => setShowPassword(!showPassword)}
        >
          {!showPassword ? <RiEyeCloseFill /> : <RiEyeFill />}
        </button>
      </div>
    </div>
  );
};

export default AuthInputPassword;
